﻿(function (document) {

    function loadDashboardContent(control) {

        return new Promise(function (resolve, reject) {

            var $control = document.querySelector(control);

            if (typeof $control == 'undefined'
                || $control == null
            ) {
                resolve();
                return;
            }

            var endpoint = $control.dataset.dashboardEndpoint;

            fetch(
                '/api/dashboard/' + endpoint + '?t=' + new Date().getTime(),
                {
                    method: 'POST',
                    contentType: 'application/json'
                }
            ).then(function (response) {
                return response.json();
            }).then(function (data) {
                $control.outerHTML = data.Response;
                console.log(endpoint + ' Loaded');
                resolve();
            }).catch(function (result) {
                console.log("error loading " + endpoint);
                console.log(result);
                resolve();
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            loadDashboardContent('[data-dashboard-endpoint=portfolioinsights]')
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=tradingwines]')
                })
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=orders]')
                })
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=portfolio-total]')
                })
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=portfolio-uk]')
                })
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=portfolio-enprimeur]')
                })
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=alerts]')
                })
                .then(function () {
                    return loadDashboardContent('[data-dashboard-endpoint=lastupdated]')
                })
                .then(function () {
                    document.querySelectorAll('[data-databoard-refresh]').forEach(function (element, index) {
                        element.addEventListener('click', function (e) {
                            e.preventDefault();

                            fetch(
                                '/api/dashboard/refreshdashboard',
                                {
                                    method: 'POST',
                                    contentType: "application/json"
                                }
                            ).then(function (result) {
                                location.reload();
                            }).catch(function (result) {
                                console.log("error refreshing dashboard");
                                console.log(result);
                            });
                        });
                    });
                })
              .then(function () {
                document.dispatchEvent(new CustomEvent("load-pies", { bubbles: true }));
                document.dispatchEvent(new CustomEvent("DashboardLoaded", { bubbles: true }));
              });
        }, 10);
    });

})(document);